import React from 'react';
import { motion } from 'framer-motion';
const useCases = [{
  icon: '🐴',
  text: 'Clubes de Polo'
}, {
  icon: '🏇',
  text: 'Academias Ecuestres'
}, {
  icon: '🎓',
  text: 'Escuelas de Polo Juvenil'
}, {
  icon: '🏆',
  text: 'Instituciones Deportivas'
}, {
  icon: '📚',
  text: 'Formación de Instructores'
}, {
  icon: '🌐',
  text: 'Clases Privadas y Particulares'
}];
export function UseCasesSection() {
  return <section className="py-10 md:py-16 bg-polo-navyLight border-y border-white/5" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-211">
        <div className="text-center mb-6 md:mb-10" data-id="element-212">
          <h2 className="text-xl md:text-3xl font-bold text-gray-300" data-id="element-213">
            Utilizado en todo tipo de contextos:
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-214">
          {useCases.map((useCase, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="glass-card rounded-xl p-4 text-center hover:bg-white/10 transition-colors" data-id="element-215">
              <div className="text-4xl mb-3" data-id="element-216">{useCase.icon}</div>
              <p className="text-sm font-medium text-gray-200" data-id="element-217">
                {useCase.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}